function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var EditorTemplate = require('./editor.template');
var _require = require('./script_build'),
  isPlaceholder = _require.isPlaceholder,
  placeholderMeta = _require.placeholderMeta,
  isWitnessPath = _require.isWitnessPath,
  lockingView = _require.lockingView,
  expandLockingTree = _require.expandLockingTree;
var _require2 = require('./script_validate'),
  getFieldDefinition = _require2.getFieldDefinition,
  validateField = _require2.validateField,
  collectPlaceholders = _require2.collectPlaceholders;
var LOGICAL_OPERATORS = ['AND', 'OR', 'NOT', 'THEN'];
var LOGICAL_OPS = new Set(['and', 'or', 'then', 'not']);
function isLogicalOperator(value) {
  return typeof value === 'string' && LOGICAL_OPERATORS.includes(value.trim().toUpperCase());
}
function normalizeLogicalOperator(value) {
  var upper = String(value || '').trim().toUpperCase();
  return LOGICAL_OPERATORS.includes(upper) ? upper : 'AND';
}
function pathToDot(path) {
  if (typeof path === 'string') {
    return path;
  }
  if (!Array.isArray(path) || path.length === 0) {
    return '';
  }
  return path.map(String).join('.');
}

/** JSON object key — opcode field name, no casing or label transforms. */
function jsonKey(key) {
  return JSON.stringify(String(key));
}
function deepClone(value) {
  return JSON.parse(JSON.stringify(value));
}

/** Opcode definition object (exampleScript). */
function resolveOpcode(mod, opName) {
  var _mod$opcodes;
  var key = String(opName || '').toLowerCase();
  var entry = mod === null || mod === void 0 || (_mod$opcodes = mod.opcodes) === null || _mod$opcodes === void 0 ? void 0 : _mod$opcodes[key];
  if (!entry) {
    return null;
  }
  if (entry.opcode && _typeof(entry.opcode) === 'object') {
    return entry.opcode;
  }
  if (entry.name || entry.exampleScript) {
    return entry;
  }
  return null;
}
function isLogicalOpName(opName) {
  return LOGICAL_OPS.has(String(opName || '').toLowerCase());
}

/**
 * Keys present on the authoritative object only.
 * Optional template order for sorting — never invents absent keys.
 */
function _keysForRender(obj, mod, panelRole) {
  if (!obj || _typeof(obj) !== 'object' || Array.isArray(obj)) {
    return [];
  }
  var present = Object.keys(obj).filter(function (key) {
    if (key === 'witness') {
      return panelRole !== 'locking';
    }
    if (key === 'required') {
      var val = obj[key];
      if (!val || _typeof(val) !== 'object' || Array.isArray(val) || Object.keys(val).length === 0) {
        return false;
      }
    }
    return Object.prototype.hasOwnProperty.call(obj, key);
  });
  var opDef = resolveOpcode(mod, obj.op);
  if (!(opDef !== null && opDef !== void 0 && opDef.exampleScript) || isLogicalOpName(obj.op)) {
    return present;
  }

  // Sort present keys by exampleScript order — never invent absent keys.
  var order = [];
  var seen = new Set();
  for (var _i = 0, _Object$keys = Object.keys(opDef.exampleScript); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (key === 'witness' || !present.includes(key) || seen.has(key)) {
      continue;
    }
    order.push(key);
    seen.add(key);
  }
  var _iterator = _createForOfIteratorHelper(present),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _key = _step.value;
      if (!seen.has(_key)) {
        order.push(_key);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return order;
}
var SemanticScriptView = /*#__PURE__*/function () {
  function SemanticScriptView(app, mod) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, SemanticScriptView);
    this.app = app;
    this.mod = mod;
    this.onPlaceholderClick = options.onPlaceholderClick || null;
    this.onFieldClick = options.onFieldClick || null;
    this.onOpcodeClick = options.onOpcodeClick || null;
    this.panelRole = options.panelRole === 'unlocking' ? 'unlocking' : 'locking';
    this.requiredOnlyEditable = options.requiredOnlyEditable === true;
    this.interactionEnabled = options.interactionEnabled !== false;
    this.container = null;
  }
  return _createClass(SemanticScriptView, [{
    key: "setRenderOptions",
    value: function setRenderOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (options.panelRole) {
        this.panelRole = options.panelRole === 'unlocking' ? 'unlocking' : 'locking';
      }
      if (options.requiredOnlyEditable !== undefined) {
        this.requiredOnlyEditable = options.requiredOnlyEditable === true;
      }
      if (options.interactionEnabled !== undefined) {
        this.interactionEnabled = options.interactionEnabled !== false;
      }
    }
  }, {
    key: "isKnownOpcode",
    value: function isKnownOpcode(name) {
      return Boolean(resolveOpcode(this.mod, name));
    }
  }, {
    key: "keysForRender",
    value: function keysForRender(obj) {
      return _keysForRender(obj, this.mod, this.panelRole);
    }
  }, {
    key: "mount",
    value: function mount(container) {
      this.container = container;
    }
  }, {
    key: "render",
    value: function render(script) {
      if (!this.container) {
        return;
      }
      this.container.innerHTML = '';
      if (!this.interactionEnabled && this.panelRole === 'unlocking') {
        return;
      }
      var tree = document.createElement('div');
      tree.className = 'rs-semantic-tree';
      tree.appendChild(this.renderValue(script, [], 0));
      this.container.appendChild(tree);
    }
  }, {
    key: "renderValue",
    value: function renderValue(value, path, depth) {
      var trailingComma = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (value === null || _typeof(value) !== 'object') {
        return this.renderPrimitiveRow(value, path, depth, trailingComma);
      }
      if (Array.isArray(value)) {
        return this.renderArray(value, path, depth, trailingComma);
      }
      return this.renderObject(value, path, depth, trailingComma);
    }
  }, {
    key: "renderPrimitiveRow",
    value: function renderPrimitiveRow(value, path, depth) {
      var trailingComma = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var row = this.createRow(depth, 'rs-semantic-row-value');
      row.appendChild(this.renderAtom(value, path));
      if (trailingComma) {
        row.appendChild(this.span(',', 'rs-semantic-punct'));
      }
      return row;
    }
  }, {
    key: "canEditPath",
    value: function canEditPath(path) {
      if (!this.interactionEnabled) {
        return false;
      }
      if (!this.requiredOnlyEditable) {
        return true;
      }
      return isWitnessPath(path);
    }
  }, {
    key: "fieldKindFor",
    value: function fieldKindFor(path) {
      var keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var value = arguments.length > 2 ? arguments[2] : undefined;
      var pathArr = path.length ? path : keyName ? [keyName] : [];
      return getFieldDefinition(value, pathArr).kind;
    }
  }, {
    key: "renderAtom",
    value: function renderAtom(value, path) {
      var keyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var readOnlyInherited = this.requiredOnlyEditable && !isWitnessPath(path);
      if (keyName === 'op' && typeof value === 'string' && isLogicalOperator(value)) {
        if (readOnlyInherited || !this.canEditPath(path)) {
          return this.span(String(value).toUpperCase(), 'rs-semantic-logical-readonly');
        }
        return this.renderLogicalOpRef(value, path);
      }
      if (keyName === 'op' && typeof value === 'string' && this.isKnownOpcode(value)) {
        if (readOnlyInherited) {
          return this.span(String(value).toUpperCase(), 'rs-semantic-opcode-readonly');
        }
        return this.renderOpcodeRef(value);
      }
      if (value === true) {
        if (readOnlyInherited) {
          return this.span('required', 'rs-semantic-inherited');
        }
        if (!this.canEditPath(path)) {
          var _fieldName = path.length ? String(path[path.length - 1]) : 'field';
          return this.span("<".concat(_fieldName, ">"), 'rs-semantic-placeholder-ghost');
        }
        var fieldName = path.length ? String(path[path.length - 1]) : 'field';
        return this.renderPlaceholderChip("<".concat(fieldName, ">"), path);
      }
      if (typeof value === 'string' && isPlaceholder(value)) {
        if (readOnlyInherited) {
          return this.span(value, 'rs-semantic-inherited');
        }
        if (!this.canEditPath(path)) {
          return this.span(this.formatPlaceholderLabel(value), 'rs-semantic-placeholder-ghost');
        }
        return this.renderPlaceholderChip(value, path);
      }
      if (readOnlyInherited) {
        return this.renderInheritedValue(value);
      }
      if (typeof value === 'string' && this.canEditPath(path)) {
        return this.renderEditableValue(value, path, keyName);
      }
      if (typeof value === 'string') {
        return this.span(JSON.stringify(value), 'rs-semantic-string');
      }
      if (typeof value === 'boolean' || typeof value === 'number') {
        if (this.canEditPath(path)) {
          return this.renderEditableValue(String(value), path, keyName);
        }
        return this.span(String(value), 'rs-semantic-literal');
      }
      if (value === null) {
        return this.span('null', 'rs-semantic-literal');
      }
      return this.span(String(value), 'rs-semantic-literal');
    }
  }, {
    key: "renderInheritedValue",
    value: function renderInheritedValue(value) {
      if (typeof value === 'string') {
        return this.span(JSON.stringify(value), 'rs-semantic-inherited');
      }
      if (typeof value === 'boolean' || typeof value === 'number') {
        return this.span(String(value), 'rs-semantic-inherited');
      }
      if (value === null) {
        return this.span('null', 'rs-semantic-inherited');
      }
      return this.span(String(value), 'rs-semantic-inherited');
    }
  }, {
    key: "renderEditableValue",
    value: function renderEditableValue(value, path, keyName) {
      var _this = this;
      var def = getFieldDefinition(value, path.length ? path : keyName ? [keyName] : []);
      var fieldKind = def.kind;
      var meta = {
        label: def.label,
        hint: def.hint || 'Click to edit',
        action: def.action
      };
      var validation = validateField(meta.action === 'text' ? fieldKind : meta.action, value, this.app);
      var display = typeof value === 'string' ? JSON.stringify(value) : String(value);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rs-value-resolved';
      if (validation.state === 'warn') {
        btn.classList.add('rs-value-resolved-warn');
        btn.title = validation.message || 'Value may be malformed — click to edit';
      } else if (validation.state === 'valid') {
        btn.classList.add('rs-value-resolved-complete');
        btn.title = 'Complete — click to edit';
      } else {
        btn.title = meta.hint || 'Click to edit';
      }
      btn.textContent = display;
      btn.dataset.path = JSON.stringify(path);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var raw = typeof value === 'string' ? value : String(value);
        if (_this.onFieldClick) {
          _this.onFieldClick(path, raw, meta, fieldKind);
        }
      });
      return btn;
    }
  }, {
    key: "formatPlaceholderLabel",
    value: function formatPlaceholderLabel(value) {
      if (typeof value === 'string') {
        return value.trim();
      }
      return String(value);
    }
  }, {
    key: "renderPlaceholderChip",
    value: function renderPlaceholderChip(value, path) {
      var _this2 = this;
      var meta = placeholderMeta(value);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rs-placeholder-chip';
      btn.textContent = this.formatPlaceholderLabel(value);
      btn.title = (meta === null || meta === void 0 ? void 0 : meta.hint) || value;
      btn.dataset.path = JSON.stringify(path);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (_this2.onPlaceholderClick) {
          _this2.onPlaceholderClick(path, value, meta);
        }
      });
      return btn;
    }
  }, {
    key: "renderOpcodeRef",
    value: function renderOpcodeRef(opName) {
      var _this3 = this;
      var key = String(opName).toLowerCase();
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rs-semantic-opcode';
      btn.textContent = String(opName).toUpperCase();
      btn.title = 'Open opcode reference';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (_this3.onOpcodeClick) {
          _this3.onOpcodeClick(key);
        }
      });
      return btn;
    }
  }, {
    key: "renderLogicalOpRef",
    value: function renderLogicalOpRef(opName, path) {
      var _this4 = this;
      var normalized = normalizeLogicalOperator(opName);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rs-semantic-logical-op';
      btn.textContent = normalized;
      btn.title = 'Change logical operator';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (_this4.onFieldClick) {
          _this4.onFieldClick(path, normalized, {
            action: 'logical',
            label: normalized,
            hint: 'Choose how conditions combine'
          }, 'logical');
        }
      });
      return btn;
    }
  }, {
    key: "renderObject",
    value: function renderObject(obj, path, depth) {
      var _this5 = this;
      var trailingComma = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var block = document.createElement('div');
      block.className = 'rs-semantic-block';
      block.dataset.depth = String(depth);
      block.dataset.path = JSON.stringify(path);
      block.dataset.kind = 'object';
      var open = this.createRow(depth, 'rs-semantic-row-brace');
      open.appendChild(this.span('{', 'rs-semantic-brace'));
      block.appendChild(open);
      var inner = document.createElement('div');
      inner.className = 'rs-semantic-block-inner';
      var keys = this.keysForRender(obj);
      keys.forEach(function (key, index) {
        var childPath = path.concat(key);
        var child = obj[key];
        var isNestedObject = child !== null && _typeof(child) === 'object' && !Array.isArray(child);
        var isNestedArray = Array.isArray(child);
        var needsTrailingComma = index < keys.length - 1;
        if (isNestedObject || isNestedArray) {
          inner.appendChild(_this5.renderNestedSection(key, child, childPath, depth, isNestedArray, needsTrailingComma));
        } else {
          var row = _this5.createRow(depth + 1, 'rs-semantic-row-value');
          row.appendChild(_this5.span(jsonKey(key), 'rs-semantic-key'));
          row.appendChild(_this5.span(':', 'rs-semantic-punct'));
          row.appendChild(_this5.renderAtom(child, childPath, key));
          if (needsTrailingComma) {
            row.appendChild(_this5.span(',', 'rs-semantic-punct'));
          }
          inner.appendChild(row);
        }
      });
      block.appendChild(inner);
      var close = this.createRow(depth, 'rs-semantic-row-brace rs-semantic-row-close');
      close.appendChild(this.span('}', 'rs-semantic-brace'));
      if (trailingComma) {
        close.appendChild(this.span(',', 'rs-semantic-punct'));
      }
      block.appendChild(close);
      return block;
    }
  }, {
    key: "renderNestedSection",
    value: function renderNestedSection(key, child, childPath, depth, isNestedArray, needsTrailingComma) {
      var section = document.createElement('div');
      section.className = 'rs-semantic-section';
      section.dataset.key = key;
      section.dataset.depth = String(depth + 1);
      section.dataset.path = JSON.stringify(childPath);
      section.dataset.kind = isNestedArray ? 'array' : 'object';
      var keyRow = this.createRow(depth + 1, 'rs-semantic-row-key');
      keyRow.appendChild(this.span(jsonKey(key), 'rs-semantic-key'));
      keyRow.appendChild(this.span(':', 'rs-semantic-punct'));
      section.appendChild(keyRow);
      section.appendChild(this.renderValue(child, childPath, depth + 1, needsTrailingComma));
      return section;
    }
  }, {
    key: "renderArray",
    value: function renderArray(arr, path, depth) {
      var _this6 = this;
      var trailingComma = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var block = document.createElement('div');
      block.className = 'rs-semantic-block rs-semantic-block-array';
      block.dataset.depth = String(depth);
      block.dataset.path = JSON.stringify(path);
      block.dataset.kind = 'array';
      var open = this.createRow(depth, 'rs-semantic-row-brace');
      open.appendChild(this.span('[', 'rs-semantic-brace'));
      block.appendChild(open);
      var inner = document.createElement('div');
      inner.className = 'rs-semantic-block-inner';
      arr.forEach(function (item, index) {
        var childPath = path.concat(index);
        var isNested = item !== null && _typeof(item) === 'object';
        if (isNested) {
          var section = document.createElement('div');
          section.className = 'rs-semantic-section';
          section.appendChild(_this6.renderValue(item, childPath, depth + 1, index < arr.length - 1));
          inner.appendChild(section);
        } else {
          var row = _this6.createRow(depth + 1, 'rs-semantic-row-value');
          row.appendChild(_this6.renderAtom(item, childPath));
          if (index < arr.length - 1) {
            row.appendChild(_this6.span(',', 'rs-semantic-punct'));
          }
          inner.appendChild(row);
        }
      });
      block.appendChild(inner);
      var close = this.createRow(depth, 'rs-semantic-row-brace rs-semantic-row-close');
      close.appendChild(this.span(']', 'rs-semantic-brace'));
      if (trailingComma) {
        close.appendChild(this.span(',', 'rs-semantic-punct'));
      }
      block.appendChild(close);
      return block;
    }
  }, {
    key: "createRow",
    value: function createRow(depth) {
      var extraClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var row = document.createElement('div');
      row.className = "rs-semantic-row ".concat(extraClass).trim();
      row.style.setProperty('--rs-depth', String(depth));
      return row;
    }
  }, {
    key: "span",
    value: function span(text, className) {
      var el = document.createElement('span');
      el.className = className;
      el.textContent = text;
      return el;
    }
  }]);
}();
var RustscriptEditor = /*#__PURE__*/function () {
  function RustscriptEditor(app, mod) {
    var _this7 = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var role = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'create';
    _classCallCheck(this, RustscriptEditor);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.role = role === 'test' ? 'test' : 'create';
    this.displayMode = 'guided';
    this.semanticView = new SemanticScriptView(app, mod, {
      panelRole: this.role === 'test' ? 'unlocking' : 'locking',
      requiredOnlyEditable: this.role === 'test',
      interactionEnabled: true,
      onPlaceholderClick: function onPlaceholderClick(path) {
        return _this7.openField(path);
      },
      onFieldClick: function onFieldClick(path) {
        return _this7.openField(path);
      },
      onOpcodeClick: function onOpcodeClick(key) {
        return _this7.openOpcode(key);
      }
    });
  }
  return _createClass(RustscriptEditor, [{
    key: "render",
    value: function render() {
      var el = document.querySelector(this.container);
      if (!el) {
        return;
      }
      if (!el.querySelector('.rustscript-editor-guided')) {
        var _this$mod;
        el.innerHTML = EditorTemplate(this.role, {
          workflow: (_this$mod = this.mod) === null || _this$mod === void 0 ? void 0 : _this$mod.workflow
        });
        var menuId = this.role === 'test' ? 'script-test' : 'script-create';
        if (el.querySelector('.rs-panel-menu')) {
          var _this$mod$main;
          (_this$mod$main = this.mod.main) === null || _this$mod$main === void 0 || _this$mod$main.bindPanelMenu(el, menuId);
        }
      }
      var titleEl = el.querySelector('.rs-panel-title');
      if (titleEl) {
        if (this.role === 'test') {
          var _this$mod2;
          titleEl.textContent = ((_this$mod2 = this.mod) === null || _this$mod2 === void 0 ? void 0 : _this$mod2.workflow) === 'unlock' ? 'Unlock Transaction' : 'Test Script';
        } else {
          titleEl.textContent = 'Create Script';
        }
      }
      var guidedEl = el.querySelector('.rustscript-editor-guided');
      var expertEl = el.querySelector('.rustscript-editor-expert');
      if (!guidedEl || !expertEl) {
        return;
      }
      var isExpert = this.displayMode === 'expert';
      el.classList.toggle('is-expert', isExpert);
      el.classList.toggle('is-guided', !isExpert);
      el.classList.toggle('rustscript-editor-locking', this.role === 'create');
      el.classList.toggle('rustscript-editor-unlocking', this.role === 'test');
      guidedEl.hidden = isExpert;
      expertEl.hidden = !isExpert;

      // Authoritative instance only — never invent fields for display.
      var script = deepClone(this.mod.getScript());
      var display = this.role === 'create' ? lockingView(script) : script;
      if (!isExpert) {
        this.semanticView.setRenderOptions({
          panelRole: this.role === 'test' ? 'unlocking' : 'locking',
          requiredOnlyEditable: this.role === 'test',
          interactionEnabled: true
        });
        this.semanticView.mount(guidedEl);
        this.semanticView.render(display);
      } else {
        expertEl.value = isEmptyScriptRoot(display) ? '' : JSON.stringify(display, null, 2);
      }
      this.attachEvents(el, expertEl);
    }
  }, {
    key: "openField",
    value: function openField(path) {
      var dot = pathToDot(path);
      if (!dot) {
        return;
      }
      var main = this.mod.main;
      if (main && typeof main.openFieldOverlay === 'function') {
        main.openFieldOverlay(dot);
      }
    }
  }, {
    key: "openOpcode",
    value: function openOpcode(key) {
      var main = this.mod.main;
      if (main && typeof main.openOpcodeReference === 'function') {
        main.openOpcodeReference(key);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(el, expertEl) {
      var _this8 = this;
      if (!el || el.dataset.rustscriptEventsAttached === '1') {
        return;
      }
      el.dataset.rustscriptEventsAttached = '1';
      if (expertEl) {
        expertEl.onchange = function () {
          commitExpert(_this8, expertEl);
        };
        expertEl.onblur = function () {
          commitExpert(_this8, expertEl);
        };
      }
    }
  }, {
    key: "getPlaceholderCount",
    value: function getPlaceholderCount() {
      var script = lockingView(deepClone(this.mod.getScript()));
      return collectPlaceholders(script, [], {
        skipRequired: true,
        skipWitness: true
      }).length;
    }
  }]);
}();
function isEmptyScriptRoot(value) {
  return value && _typeof(value) === 'object' && !Array.isArray(value) && Object.keys(value).length === 0;
}
function commitExpert(_x, _x2) {
  return _commitExpert.apply(this, arguments);
}
function _commitExpert() {
  _commitExpert = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(editor, expertEl) {
    var _editor$mod;
    var _require3, isUnlockEditable, parsed, expanded, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!(editor.displayMode !== 'expert')) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          if (!(((_editor$mod = editor.mod) === null || _editor$mod === void 0 ? void 0 : _editor$mod.workflow) === 'unlock')) {
            _context.n = 2;
            break;
          }
          _require3 = require('./unlock_tx_fee'), isUnlockEditable = _require3.isUnlockEditable;
          if (isUnlockEditable(editor.mod)) {
            _context.n = 2;
            break;
          }
          // Transaction is locked — restore the authorized script (guided witness overlays still work).
          try {
            expertEl.value = JSON.stringify(editor.mod.getScript(), null, 2);
          } catch (_err) {
            /* ignore */
          }
          return _context.a(2);
        case 2:
          _context.p = 2;
          parsed = JSON.parse(expertEl.value);
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          return _context.a(2);
        case 4:
          if (editor.role === 'create') {
            expanded = expandLockingTree(lockingView(parsed), editor.mod.opcodes);
            editor.mod.setScript(expanded);
          } else {
            editor.mod.setScript(parsed);
          }
          if (!editor.mod.main) {
            _context.n = 5;
            break;
          }
          _context.n = 5;
          return editor.mod.main.refresh();
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[2, 3]]);
  }));
  return _commitExpert.apply(this, arguments);
}
module.exports = RustscriptEditor;